import { render, staticRenderFns } from "./single-algorithm-popup.vue?vue&type=template&id=450f4ba0"
import script from "./single-algorithm-popup.vue?vue&type=script&lang=js"
export * from "./single-algorithm-popup.vue?vue&type=script&lang=js"
import style0 from "./single-algorithm-popup.vue?vue&type=style&index=0&id=450f4ba0&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports